import { render, staticRenderFns } from "./ModalWait.vue?vue&type=template&id=37f175c7"
import script from "./ModalWait.vue?vue&type=script&lang=js"
export * from "./ModalWait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports